import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const selectOrganizationState = (state: RootState) => state.organization;

export const selectMessageBrokerMultiaddr = createSelector(
  selectOrganizationState,
  (state) => state.messageBrokerMultiaddr
);
